<!--  -->
<template>
  <div>
    <div class="band_box">
      <div>
        <div class="serch_box">
          <el-input
            v-model="obr.phone_name"
            clearable
            style="width:300px;margin-right:10px"
            placeholder="请输入手机名称"
          />
          <el-select
            v-model="obr.only_me"
            placeholder="请选择"
            style="width:150px;margin-right:5px"
          >
            <el-option
              v-for="item in accountarr"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            />
          </el-select>
          <el-button
            type="primary"
            class="search_icon"
            icon="el-icon-search"
            @click="secahclkick"
          />
        </div>
        <div class="choses_box">
          <div
            class="select_box"
            :class="[fullName?'choose_blockr':'']"
            @click="whole"
          />
          <div
            v-if="fullName"
            @click="whole"
          >
            取消全选
          </div>
          <div
            v-else
            @click="whole"
          >
            全选
          </div>
        </div>
        <div class="choose_allblock">
          <div
            v-for="item,index in arr"
            :key="index"
            :class="[item.tips?'have ':'']"
            class="choose_block"
          >
            <!-- {{ item.canChecked }} -->
            <div
              v-if="item.can_checked === 9"
              class="select_boxone"
            />
            <div
              v-else
              class="select_box"
              :class="[item.tips?'choose_blockr':'']"
              @click="itenclick(item,index)"
            />
            <span>{{ item.phone_name }}</span>
          </div>
        </div>
        <pagination-right
          style="padding:0px;margin-top:20px"
          :total="total"
          :current-page="obr.page"
          :page-size="30"
          :page-sizes="[10,20,30]"
          @size-change="fetchPageSize"
          @current-change="fetchCurrentPage"
        />
      </div>
      <div class="rigboxr">
        <div class="choiceofficialaccount">选中的手机</div>
        <el-tag
          v-for="itemr,index in arrs"
          :key="index"
          style="margin-right:10px;margin-bottom:5px"
          closable
          :type="itemr.type"
          @close="rightclick(itemr.id,index)"
        >
          {{ itemr.phone_name }}
        </el-tag>
      </div>
    </div>

    <div class="que_box">
      <el-button
        type="primary"
        @click="quebtn"
      >确定</el-button>
    </div>

  </div>
</template>

<script>
import PaginationRight from '@/components/PaginationRight/index.vue'
import convertToHump from '@/utils/mixins/convertToHump.js'
import { phonelistForUpgrade, issuedota } from '@/api/stwert.js'
export default {
  components: {
    PaginationRight
  },
  mixins: [convertToHump],
  data() {
    return {
      searchvalue: null,
      searchTopicLoading: false, // 搜索锁
      topicList: [], // 公众号临时绑定数组
      options: [], // 公众号列表数组
      value1: [], // 公众号多选完成集合数组
      id: null, // 点击保存的id
      tableData: [], // 表格数组
      arr: [],
      arrs: [],
      arrsw: [],

      obr: {
        page: 1,
        page_size: 30,
        only_me: 1,
        phone_name: ''
      },
      total: null,
      sp_strategy_no: null,
      accountarr: [
        {
          value: 1,
          label: '组内手机'
        },
        {
          value: 2,
          label: '我的手机'
        }
      ],
      chuanid: null
    }
  },
  computed: {
    fullName: function() {
      return this.arr
        .filter(num => {
          return num.can_checked !== 9
        })
        .every(function(item) {
          return item.tips === true
        })
    }
  },
  created() {},
  mounted() {},
  methods: {
    secahclkick() {
      this.obr.page = 1
      this.list()
    },

    // 点击确定
    async quebtn() {
      console.log('arrs', this.arrs)
      if (this.arrs.length === 0) {
        this.$message.error('请选择要绑定的手机')
        return
      }
      this.arrsw = []
      this.arrsw = this.arrs.map(item => {
        // item是数组中的每一个值
        return item.id
      })
      issuedota({
        id: this.chuanid,
        phone_ids: this.arrsw
      }).then(res => {
        this.$emit('updataloading')
        this.$message({
          type: 'success',
          message: '下发成功!'
        })
      })
    },

    itenclick(item, index) {
      item.tips = !item.tips
      if (item.tips) {
        this.arrs.push({ id: item.id, phone_name: item.phone_name })
      } else {
        const index = this.arrs.findIndex(items => {
          return items.id === item.id
        })
        this.arrs.splice(index, 1)
      }
    },
    whole() {
      if (this.fullName === true) {
        // if (this.arrs.length === this.arr.length) {
        console.log('666')
        this.arr.forEach(item => {
          if (item.can_checked === 1) {
            item.tips = false
            const index = this.arrs.findIndex(items => {
              return items.id === item.id
            })
            this.arrs.splice(index, 1)
          }
        })
      } else {
        console.log('777')
        this.arr.forEach(item => {
          if (item.can_checked === 1) {
            item.tips = true
            this.arrs.map(re => re.id).includes(item.id) || this.arrs.push({ id: item.id, phone_name: item.phone_name })
          }
        })
        // this.arr.forEach((item) => {
        //   this.arrs.includes(item.id) || this.arr.push(item.id)
        // })
      }
    },
    rightclick(id, index) {
      console.log(id, index)
      this.arrs.splice(index, 1)
      this.arr.findIndex(items => {
        if (items.id === id) {
          items.tips = false
        }
      })
    },
    sendr(id) {
      this.chuanid = id
      this.list()
    },
    async list() {
      const data = await phonelistForUpgrade(this.obr)
      this.total = data.data.total
      data.data.list.forEach(item => {
        item.tips = false
      })
      this.arr = data.data.list
      this.arr.forEach(item => {
        item.can_checked = 1
        // console.log('item', item)
        this.arrs.forEach(items => {
          if (items.id === item.id) {
            console.log('items', item)
            item.tips = true
          }
        })
      })
      console.log('data', data)
    },
    // 分页
    fetchPageSize(e) {
      console.log('111')
      this.obr.page_size = e
      this.obr.page = 1
      this.list()
    },
    fetchCurrentPage(e) {
      this.obr.page = e
      this.list()
    }
  }
}
</script>
<style scoped>
/* @import url(); 引入css类 */
.allbox {
  padding: 30px;
}
.que_box {
  margin-top: 20px;
}
.have {
  color: #409eff;
}
.serch_box {
  display: flex;
  margin-bottom: 10px;
}
.search_icon {
  margin-left: 10px;
}
.band_box {
  display: flex;
}
.choses_box {
  margin-bottom: 10px;
  display: flex;
  align-items: center;
}
.select_box {
  height: 14px;
  width: 14px;
  border-radius: 3px;
  border: 1px solid skyblue;
  margin-right: 7px;
}
.select_boxone {
  height: 14px;
  width: 14px;
  border-radius: 3px;
  border: 1px solid #ccc;
  margin-right: 7px;
  background-color: #ccc;
}
.choose_block {
  display: flex;
  align-items: center;
  margin-bottom: 5px;
  margin-right: 10px;
}
.choose_blockr {
  background: #409eff;
}
.rigboxr {
  margin-left: 85px;
  border-left: 1px solid #ccc;
  padding-left: 30px;
  max-height: 520px;
  overflow: hidden;
  overflow-y: scroll;
}
:-webkit-scrollbar {
  width: 0 !important;
}
::-webkit-scrollbar {
  width: 0 !important;
  height: 0;
}
.choiceofficialaccount {
  margin-bottom: 10px;
}
.select_spacing {
  margin-bottom: 5px;
}
.choose_allblock {
  height: 370px;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  flex-wrap: wrap;
}
@media (max-width: 768px) {
  .band_box{
    flex-direction:column;
  }
  .rigboxr{
    margin:0px;
    margin-top:10vw;
    padding-left:5vw;
  }
  .que_box {
    height:6vw;
  }
  .que_box button{
    float:right;
  }
  .choose_allblock{
    height:50vw;
    overflow:auto;
  }
}
</style
>
